import React from 'react';
import Loader from 'react-loader-spinner';

const LoaderSpinner = () => {
  return (
    <div className="pb-16 flex flex-col items-center justify-center">
      <h3 className="text-2xl text-white mb-8">
        Please wait while we process your information. This may take a few
        minutes...
      </h3>
      <Loader type="TailSpin" color="#209287" height={100} width={100} />
    </div>
  );
};

export default LoaderSpinner;
